/**
 * pm2 forwards stdout and stderr byte-for-byte, so anything a process wrote
 * with colour still carries its ANSI escapes. A terminal renders those; a
 * browser prints the control characters as replacement glyphs in the middle of
 * the message, which is how an `info` tag arrives on screen wrapped in the raw
 * `[32m` / `[39m` codes.
 *
 * The bridge keeps the raw bytes on purpose — the phone app and any future
 * consumer should get exactly what the process wrote — so they are stripped
 * here, at the point of display.
 */

/**
 * CSI sequences (colour, cursor movement) and the OSC form used for window
 * titles and hyperlinks, which ends at BEL or ST rather than a final byte.
 */
const ANSI = new RegExp(
  [
    '\\u001B\\[[0-9;?]*[ -/]*[@-~]', // CSI ... final
    '\\u001B\\][\\s\\S]*?(?:\\u0007|\\u001B\\\\)', // OSC ... BEL | ST
    '\\u001B[@-Z\\\\-_]', // two-character escapes
  ].join('|'),
  'g',
);

/**
 * Carriage returns and stray control bytes left by progress bars and spinners.
 * Tab and newline are kept: a process that indented its output meant to.
 */
const CONTROL = /[\u0000-\u0008\u000B-\u001F\u007F]/g;

export function stripAnsi(text: string): string {
  return text.replace(ANSI, '').replace(CONTROL, '');
}
